

<table mat-table matSort [dataSource]="orderItems" class="w-100">
  
    <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>Name</th>
        <td mat-cell *matCellDef="let item"> {{ item.medicine_dosage_package_type.label_name ? item.medicine_dosage_package_type.label_name : '-'}} </td>
    </ng-container>

    <!-- <ng-container matColumnDef="dosage">
        <th mat-header-cell *matHeaderCellDef>Dosage</th>
        <td mat-cell *matCellDef="let item"> {{ item.dosageType.additional_information }} </td>
    </ng-container> -->

    <!-- <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>Status</th>
        <td mat-cell *matCellDef="let item">
            <p class="status">
                <mat-form-field appearance="outline">
                    <mat-label>Status</mat-label>
                    <mat-select [value]="getStatus(item)" [disabled]="isLoading"
                        (selectionChange)="changeOrderItemStatus($event, item)">
                        <mat-option *ngFor="let status of orderItemStatuses" [value]="status">
                            {{status.status}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </p>
        </td>
    </ng-container> -->

    <ng-container matColumnDef="quantity">
        <th mat-header-cell *matHeaderCellDef>Quantity</th>
        <td mat-cell *matCellDef="let item"> {{item.medicine_dosage_package_type.contained_quantity}} </td>
    </ng-container>
    <ng-container matColumnDef="fulfilled">
        <th mat-header-cell *matHeaderCellDef>Fulfilled</th>
        <td mat-cell *matCellDef="let item"> {{item.batch_items.length}} </td>
    </ng-container>

    <ng-container matColumnDef="details">
        <th mat-header-cell *matHeaderCellDef>&nbsp;</th>
        <td mat-cell *matCellDef="let item" class="text-end">

                    <button *ngIf="order" mat-stroked-button (click)="openDetails(item)" class="me-2">
                        <mat-icon>info</mat-icon> Details
                    </button>

        </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>